import React, { useEffect, useRef, useState } from 'react'
import Navbar from '../Navbar'
import { Link, NavLink } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import Footer from '../Footer';

import { FiMinus } from "react-icons/fi";
import { FiPlus } from "react-icons/fi";
import DownloadAfriPay from "../DownloadAfriPay";
import WhyUseAfriPay from '../WhyUseAfriPay';
import Lottie from 'lottie-react';
import globalAccountAnimationData from "../../animations/instantTransferAnimation.json";
import { SEO } from '../SEO';
import { FaAngleDown, FaAngleUp, FaRegArrowAltCircleRight } from 'react-icons/fa';
import ActionButtons from '../ActionButtons';
import { motion } from "framer-motion";
import HeroCTA1 from '../HeroCTA1';
import HeroCTA2 from '../HeroCTA2';
import { useDownloadAppModal } from '../../context/DownloadAppModalContext';

const slideInLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const slideInRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const fadeUpImage = {
  hidden: { opacity: 0, y: 40, scale: 0.96 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.7, ease: "easeOut" },
  },
};

function GlobalAccount() {
  const [isIOS, setIsIOS] = useState(false);
  const { openDownloadModal } = useDownloadAppModal();


  useEffect(() => {
    const detected =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    setIsIOS(detected);
  }, []);
  return (
    <>

      <style>{`
               

                
            `}</style>

      <SEO
        title="Global Account | Afripay"
        description="Open Global Accounts for international transactions on Afripay."
        canonical="https://goafripay.com/global-account"
      />

      <Navbar />

      {/* Hero Section */}
      <section className="hero-gradient-bg" >
        <div className="max-w-7xl mx-auto pt-[120px] md:pt-[140px] pb-[40px]">
          <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className="grid px-8 lg:px-16 lg:gap-8 xl:gap-0 lg:grid-cols-12 justify-center lg:justify-start">
            <motion.div variants={slideInLeft} className="lg:mr-auto flex flex-col items-center lg:items-start text-center lg:text-left place-self-center lg:col-span-6">
              <h1 className=" text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-[#030319] font-display-fran font-bold leading-[1.1] tracking-[-0.02em] drop-shadow-lg">
                Access Worldwide <br />
                Payment Services
              </h1>


              <p className=' text-base sm:text-lg lg:text-[16px] text-[#030319] font-display-fran font-medium leading-[1.6] tracking-wide max-w-[430px] mt-5 drop-shadow-lg'>
                Get USD, EUR, and GBP accounts with IBAN numbers. Send and receive international payments like a local.
              </p>

              <div className=" flex flex-col gap-4 md:flex-row lg:items-start items-center md:gap-8 space-x-3 lg:mt-14 mt-7">
                <div className='mt-5 lg:mt-0'>

                  <button
                    className="px-8 py-4 text-base text-white bg-[#209D5A]  hover:bg-[#0F5132] rounded-[100px] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02]"
                    onClick={openDownloadModal}
                  >
                    Get started now
                  </button>

                </div>

              </div>


            </motion.div>
            <motion.div variants={slideInRight} className=" lg:mt-0 lg:col-span-6 lg:flex lg:justify-end w-full md:mt-0 mt-[50px]">
              <Lottie
                animationData={globalAccountAnimationData}
                loop={true}
                autoPlay={true}
                className="w-full h-[432px] max-w-[1000px] hidden md:block"
              />
              <img src="/images/global_account_hero.avif" alt="Instant Transfer" className="md:w-[486px] lg:w-[390px] hidden md:block absolute md:bottom-[280px] lg:bottom-[200px] md:right-[140px] lg:right-[217px] z-10" />
              <img src="/images/globalHero3.avif" alt="Instant Transfer" className="w-full block md:hidden" />
            </motion.div>
          </motion.div>
        </div>
      </section>



      {/* One Account, Global Power */}
      <div className="bg-[#fff] py-16 px-4">
        <div className="max-w-7xl mx-auto mb-11">
          {/* Header */}
          <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className='mb-8 lg:mb-16 text-left space-y-3'>
            <motion.h1 variants={fadeUp} className="text-[24px] sm:text-3xl lg:text-3xl xl:text-4xl font-[600] font-display text-gray-900">
              One Account, Global Power
            </motion.h1>
            <motion.p variants={fadeUp} className='text-[#0A0A0A] text-lg'>Everything you need to manage your finances across borders</motion.p>
          </motion.div>

          {/* Cards Grid */}
          <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.05 }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

            {/* Card 1 */}
            <motion.div variants={fadeUp} className='rounded-3xl border border-[#E5E7EB] flex justify-center p-4'>
              <div className='flex flex-col items-center'>
                <img src="/images/oneAccount.avif" alt="One Account" width={355} height={453} />
                <div className='pt-11 px-4 pb-5 font-display-fran'>
                  <h2 className='text-[#101828] font-bold text-2xl'>Go Global with AfriPay</h2>
                  <p className='text-[#4A5565] text-base'>Send and receive money across borders with zero hassle. Support for 150+ countries and multiple currencies.</p>
                </div>
              </div>
            </motion.div>

            {/* Card 2 */}
            <motion.div variants={fadeUp} className='rounded-3xl border border-[#E5E7EB] flex justify-center p-4'>
              <div className='flex flex-col items-center'>
                <img src="/images/oneAccount2.avif" alt="One Account" width={355} height={453} />
                <div className='pt-11 px-4 pb-5 font-display-fran'>
                  <h2 className='text-[#101828] font-bold text-2xl'>Better Currency Conversion</h2>
                  <p className='text-[#4A5565] text-base'>Get the best exchange rates with real-time currency conversion. Save more on every transaction.</p>
                </div>
              </div>
            </motion.div>

            {/* Card 3 */}
            <motion.div variants={fadeUp} className='rounded-3xl border border-[#E5E7EB] flex justify-center p-4'>
              <div className='flex flex-col items-center'>
                <img src="/images/oneAccount3.avif" alt="One Account" width={355} height={453} />
                <div className='pt-11 px-4 pb-5 font-display-fran'>
                  <h2 className='text-[#101828] font-bold text-2xl'>Pay Utilities from Anywhere</h2>
                  <p className='text-[#4A5565] text-base'>Manage all your bills in one place. Pay utilities, subscriptions, and services from anywhere in the world.</p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
        <div className='w-full flex justify-center'>
          <button className="h-13 rounded-lg bg-[#0B7F47] border-2 border-[#7FBC51] shadow-sm text-white text-sm p-3.5 cursor-pointer transition-colors duration-300 hover:bg-[#0B7F47]/60" onClick={openDownloadModal}>Open Afripay Account</button>
        </div>
      </div>

      <div className='max-w-7xl mx-auto flex items-center justify-center px-5 md:px-0'>
        <img src="/images/whyUseAfripay.avif" alt="Why Use Afripay" className='hidden md:block md:w-full lg:max-w-[1000px]' />
        <img src="/images/whyUseAfripayMobile.avif" alt="Why Use Afripay" className='w-full block md:hidden' />
      </div>

      {/* Simple Steps to Start Enjoying AfriPAy */}

      <div className="w-full px-4 py-16">
        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} className="max-w-7xl mx-auto">
          {/* Header */}
          <motion.h2 variants={fadeUp} className="text-3xl md:text-4xl font-bold text-center font-display-fran text-gray-900 mb-3">
            Simple Steps to Start Enjoying AfriPay
          </motion.h2>
          <motion.p variants={fadeUp} className='mb-8 text-[#0A0A0A] text-center'>Get started in three easy steps and unlock global financial freedom</motion.p>

          {/* Steps Container */}
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-0 items-center justify-between">
            <motion.img variants={fadeUpImage} src="/images/simple_step_1.avif" alt="Simple Step 1" className='w-full lg:w-[380px]' />
            <motion.img variants={fadeUpImage} src="/images/simple_step_2.avif" alt="Simple Step 2" className='w-full lg:w-[380px]' />
            <motion.img variants={fadeUpImage} src="/images/simple_step_3.avif" alt="Simple Step 3" className='w-full lg:w-[380px]' />
          </div>
        </motion.div>
      </div>

      <section className='max-w-7xl mx-auto py-5 lg:py-20 space-y-11'>
        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          <motion.h2 variants={fadeUp} className='font-display-fran text-[#0A0A0A] text-3xl font-semibold mb-3'>Payment Without Borders</motion.h2>
          <motion.p variants={fadeUp} className='text-[#0A0A0A] text-base'>Everything you need to manage your money globally.</motion.p>
        </motion.div>
        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
          <motion.img variants={fadeUpImage} src="/images/digital_cards.avif" alt="Digital Cards" className='mb-11 hidden lg:block' />
          <motion.img variants={fadeUpImage} src="/images/digital_cards_mobile.avif" alt="Digital Cards" className='mb-11 block lg:hidden' />
          <div className='flex flex-col lg:flex-row items-center justify-between gap-11 lg:gap-0'>
            <motion.img variants={fadeUpImage} src="/images/global_payment.avif" alt="Global Payment" width={580} className='hidden lg:block' />
            <motion.img variants={fadeUpImage} src="/images/global_payment_mobile.avif" alt="Global Payment" className='block lg:hidden' />
            <motion.img variants={fadeUpImage} src="/images/instant_payment.avif" alt="Instant Payment" width={580} className='hidden lg:block' />
            <motion.img variants={fadeUpImage} src="/images/instant_payment_mobile.avif" alt="Instant Payment" className='block lg:hidden' />
          </div>
        </motion.div>
        <motion.div variants={slideInRight} className='flex justify-center lg:justify-end'>
          <ActionButtons />
        </motion.div>
        {/* <div className='flex flex-row items-center justify-center lg:justify-end gap-4'>
          <img src="/images/playStore.png" alt="Play Store" width={160} height={52} />
          <img src="/images/appStore.png" alt="App Store" width={160} height={52} />
        </div> */}
      </section>


      {/* FAQ SECTION */}
      <section className="w-full px-4 pt-10 md:pt-20 pb-10">
        <div className="max-w-7xl mx-auto">
          <div className="w-full flex flex-col md:flex-row items-start md:items-end justify-between mb-8 font-display-fran">
            <div className="flex flex-col text-left gap-3 mb-4 md:mb-0">
              <h2 className="text-2xl sm:text-2xl lg:text-4xl text-[#030319] font-display font-bold">
                Everything You Need to Know
              </h2>
              <p className="text-[#344054] text-lg">Discover how AfriPay works and what makes us different</p>
            </div>
            <Link to={'/faq'} className="text-[#024529] flex items-center justify-center gap-1.5 cursor-pointer transition-all duration-300 hover:text-gray-600">
              View All <FaRegArrowAltCircleRight />
            </Link>
          </div>
          <div className="gap-8 lg:mt-16 mt-8 ">
            <div className="lg:col-span-8 col-span-12">
              <Accordion allowZeroExpanded allowMultipleExpanded>
                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                  <AccordionItemHeading>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <AccordionItemButton
                          className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                          aria-expanded={expanded}
                        >
                          <span>What is AfriPay?</span>
                          <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                            {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                          </span>
                        </AccordionItemButton>
                      )}
                    </AccordionItemState>
                  </AccordionItemHeading>
                  <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                    <p className="w-[940px]">
                      AfriPay is an innovative platform simplifying
                      international tuition payments, securing educational
                      loans, and offering a digital wallet feature for
                      seamless financial transactions.
                    </p>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                  <AccordionItemHeading>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <AccordionItemButton
                          className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                          aria-expanded={expanded}
                        >
                          <span>How does AfriPay simplify tuition payments?</span>
                          <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                            {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                          </span>
                        </AccordionItemButton>
                      )}
                    </AccordionItemState>
                  </AccordionItemHeading>
                  <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                    <p className="w-[940px]">
                      AfriPay streamlines the tuition payment process, providing a user-friendly interface and multiple payment options for efficient and secure transactions.
                    </p>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                  <AccordionItemHeading>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <AccordionItemButton
                          className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                          aria-expanded={expanded}
                        >
                          <span>What security measures does AfriPay have in place?</span>
                          <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                            {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                          </span>
                        </AccordionItemButton>
                      )}
                    </AccordionItemState>
                  </AccordionItemHeading>
                  <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                    <p className="w-[940px]">
                      AfriPay employs cutting-edge encryption technologies to ensure the security and confidentiality of user data, providing a safe environment for financial transactions.
                    </p>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                  <AccordionItemHeading>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <AccordionItemButton
                          className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                          aria-expanded={expanded}
                        >
                          <span>What is the digital wallet feature in AfriPay?</span>
                          <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                            {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                          </span>
                        </AccordionItemButton>
                      )}
                    </AccordionItemState>
                  </AccordionItemHeading>
                  <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                    <p className="w-[940px]">
                      The digital wallet feature allows users to conveniently manage and access funds, enabling cashless transactions, budgeting, and automated savings.
                    </p>
                  </AccordionItemPanel>
                </AccordionItem>

                <AccordionItem className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                  <AccordionItemHeading>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <AccordionItemButton
                          className={`py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2`}
                          aria-expanded={expanded}
                        >
                          <span>How does AfriPay support educational loans?</span>
                          <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
                            {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
                          </span>
                        </AccordionItemButton>
                      )}
                    </AccordionItemState>
                  </AccordionItemHeading>
                  <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                    <p className="w-[940px]">
                      AfriPay assists users in securing educational loans, streamlining the application process, and providing transparent terms for quick approvals.
                    </p>
                  </AccordionItemPanel>
                </AccordionItem>

              </Accordion>

            </div>
          </div>
          <div className="w-full flex justify-center pt-5">
            <button type="button" onClick={openDownloadModal} className="w-[174px] h-13 rounded-lg bg-[#0B7F47] border-2 border-[#7FBC51] shadow-sm text-white text-sm p-3.5 cursor-pointer transition-colors duration-300 hover:bg-[#0B7F47]/60">Get started — it's free</button>
          </div>
        </div>
      </section>


      <div className='max-w-7xl mx-auto mb-4 lg:mb-8'>
        <HeroCTA1 />
        <HeroCTA2 />
      </div>

      {/* Download AfriPay App */}
      <DownloadAfriPay />

      {/* <-- Footer --> */}
      <Footer />

    </>
  )
}

export default GlobalAccount